import { c as _c } from "react/compiler-runtime";
import { HotelCalendarType } from "@website/accommodation-ui/hotel-calendar/hotel-calendar.type";
import { MaterialIcon } from "@website/icons/material";
import { Datepicker } from "@website/ui/datepicker";
export const HotelCalendar = properties => {
  const $ = _c(16);
  const {
    calendarDate,
    onCalendarChange,
    calendarData,
    disableLimit,
    disableDates,
    showTitle: t0,
    isLabelTop: t1
  } = properties;
  const showTitle = t0 === undefined ? false : t0;
  const isLabelTop = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== showTitle) {
    t2 = showTitle && <div className="text-subtitle-1 md:text-headline-6 pb-4">تقویم و نرخ قیمتی</div>;
    $[0] = showTitle;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `${isLabelTop ? "relative" : ""} border-outline-thin z-[5] rounded-lg border p-3 md:p-4`;
  let t4;
  if ($[2] !== calendarData || $[3] !== calendarDate || $[4] !== disableDates || $[5] !== disableLimit || $[6] !== isLabelTop || $[7] !== onCalendarChange) {
    t4 = <Datepicker calendarData={calendarData} disableDates={disableDates} disableLimit={disableLimit} mode="range" onChange={onCalendarChange} type="flat" value={calendarDate} isLabelTop={isLabelTop} />;
    $[2] = calendarData;
    $[3] = calendarDate;
    $[4] = disableDates;
    $[5] = disableLimit;
    $[6] = isLabelTop;
    $[7] = onCalendarChange;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="border-outline-thin flex items-center gap-1 border-t pt-4"><MaterialIcon className="text-warning" name="bolt" /><span className="text-caption">در این رزروها بدون نیاز به تایید میزبان، آنی رزرو کنید.</span></div>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t4) {
    t6 = <div className={t3} id="hotel_calendar">{t4}{t5}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== t6) {
    t7 = <div>{t2}{t6}</div>;
    $[13] = t2;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};